import styles from './styles.module.scss';
import HostCard from '@/components/app/HostCard';
import useShow from '@/hooks/shows/useShowFromURL';

const AboutSection = () => {
  const { show, isLoading } = useShow();

  const {
    description,
    hosts,
    external_links: links,
    network,
    origin,
    genres,
    release_date
  } = show;

  const releaseYear = new Date(release_date).getFullYear();

  return (
    <HostCard
      className={ styles.aboutSection }
      description={ description }
      from={ origin }
      genres={ genres }
      hosts={ hosts }
      links={ links }
      loading={ isLoading }
      network={ network?.title }
      releaseYear={ releaseYear }
    />
  );
};

export default AboutSection;